import { Employees } from 'modules/employees/store/collections/employees'
import type Supplement from 'modules/payroll_bundle/store/models/Supplement'

export const supplementEmployee = (supplement: Supplement, employees: Employees) => {
  if (!supplement.has('employee_id')) return null

  return employees.get(supplement.attributes.employee_id)
}
